
















// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartContainer from '@/components/charts/ChartContainer.vue';
import ChartStandardScoring from '@/components/charts/standard/ChartStandardScoring.vue';
import { usePodocoreModule } from '@/plugins/podocore';

export default defineComponent({
  name: 'ChartWalkingWidgetScoringGVI',
  components: {
    ChartContainer,
    ChartStandardScoring
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    },
    analysis: {
      type: Object,
      required: true
    },
    simple: {
      type: Boolean
    }
  },
  setup(properties) {
    const busModule = usePodocoreModule('bus');

    const onShowMore = () => {
      busModule.publish(
        busModule.events.openDialog({
          id: 'analysis-SQI',
          meta: { analysis: properties.analysis }
        })
      );
    };

    return {
      onShowMore
    };
  }
});
